import React, { useState, memo, useCallback, useEffect } from "react";
import cns from "classnames";
import { makeStyles } from "@material-ui/core";
import { omit } from "@bonliva-crm/common";
import { SelectProps, MultiSelectProps } from "@common/Select";
import { SearchSelect } from "@common/Select/SearchSelect";

type Props = (MultiSelectProps | SelectProps) & {
  onSelect: (o: any) => void;
  initialOption: string;
};

const PROPS_TO_OMIT: string[] = ["onSelect"];

function SelectButton(props: Props): React.ReactElement<Props> {
  const [currentValue, setCurrentValue] = useState<string>(props.initialOption || null);
  const classes = useStyles({});

  const handleChange = useCallback(
    (optionValue: string) => {
      setCurrentValue(optionValue);
      props.onSelect(optionValue);
    },
    [props.options]
  );

  const selectProps = omit(props, PROPS_TO_OMIT as any);

  useEffect(() => {
    setCurrentValue(props.initialOption);
  }, [props.initialOption]);

  return (
    <SearchSelect
      {...selectProps}
      sortOptions={false}
      className={cns(classes.selectStyles, props.className)}
      onChange={handleChange}
      value={currentValue}
      clearable={false}
      label={props.label}
      options={props.options}
    />
  );
}

const useStyles = makeStyles({
  selectStyles: {
    width: "100%",
    "& > div": {
      // boxShadow: "0px 3px 5px 1px #B7B7B7"
    },
    "& .Select_label": {
      left: 10,
      color: "#000000"
    },
    "& .Select": {
      padding: 10
    }
  }
});

export default memo(SelectButton);
